import React, { useEffect } from 'react';

const OkModal = ({ message, onClose }) => {
  
  useEffect(() => {
    const timer = setTimeout(onClose, 5000); // 2000ms = 2 seconds

     return () => clearTimeout(timer);
  }, [onClose]);

  return (
    <div  onClick={onClose} style={{
      position: 'fixed',
      top: '50px',
      left: '50%', 
      transform: 'translate(-50%, -50%)',
      width: '350px',
      backgroundColor: 'rgb(255 255 255)',
      padding: '12px 16px',
      zIndex: 1000, 
      borderRadius: '10px',
      border: '1px solid #14b8a6',
      cursor: 'pointer',
    }}

    > 
      <h3 style={{ margin: '0',  color: '#14b8a6', fontWeight: 'bold',  }}>Success</h3>
      <p style={{ margin: '0',  color: '#14b8a6',  }}>{message}</p> 
    </div>
  );
};

export default OkModal;
